import { createReducer } from 'redux-create-reducer';
import { fetchSitesAction, fetchSitesSuccessAction } from '../actions/sites';

const initialState = {
  choice: [],
  isFetching: false,
};

export const sitesReducer = createReducer(initialState, {
  [fetchSitesAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [fetchSitesSuccessAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
});

export default sitesReducer;

export const getSites = state => state.sites.choice;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/reducers/sites.js